var React = require('react');

function IconTaskSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M920 704.2H106c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V712.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H580.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H829c2.2 0 4 1.8 4 4v57zM921 419.2H107c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V427.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H581.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H830c2.2 0 4 1.8 4 4v57zM921 128.2H107c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V136.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H581.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H830c2.2 0 4 1.8 4 4v57z"}));
}

IconTaskSolid.displayName = "IconTaskSolid";

IconTaskSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconTaskSolid;

IconTaskSolid.default = IconTaskSolid;
